import SendReceiptMultiStep from './sendReceiptMultistep';

export default SendReceiptMultiStep;
